import { BaseConfidential } from './confidential';
const LOG_TYPES = ['debug', 'trace', 'info', 'warn', 'error'];
const ALLOWED_TYPES = [Boolean, Number, String, Array];
export class TeeLogger {
    loggers;
    debug;
    trace;
    info;
    warn;
    error;
    constructor(loggers) {
        this.loggers = loggers;
        for (const type of LOG_TYPES) {
            this[type] = this.forward.bind(this, type);
        }
    }
    forward(type, message, ...args) {
        for (const log of this.loggers) {
            log[type](message, ...args);
        }
    }
}
export class LevelLogger {
    logger;
    level;
    debug = this.noop;
    trace = this.noop;
    info = this.noop;
    warn = this.noop;
    error = this.noop;
    constructor(logger, level) {
        this.logger = logger;
        this.level = level;
        switch (level) {
            case 'debug':
                this.debug = this.logger.debug.bind(this.logger);
                this.trace = this.logger.trace.bind(this.logger);
            case 'info':
                this.info = this.logger.info.bind(this.logger);
            case 'warn':
                this.warn = this.logger.warn.bind(this.warn);
            case 'error':
                this.error = this.logger.error.bind(this.error);
            default:
                break;
        }
    }
    noop() {
    }
}
export class TagLogger {
    logger;
    debug;
    trace;
    info;
    warn;
    error;
    constructor(logger, ...tag) {
        this.logger = logger;
        for (const type of LOG_TYPES) {
            this[type] = logger[type].bind(logger, ...tag);
        }
    }
}
export class UnveilLogger {
    logger;
    debug;
    trace;
    info;
    warn;
    error;
    constructor(logger) {
        this.logger = logger;
        for (const type of LOG_TYPES) {
            this[type] = this.unveil.bind(this, type);
        }
    }
    unveil(type, ...args) {
        args = args.map((item) => item instanceof BaseConfidential ? item.uncensored : item);
        this.logger[type](...args);
    }
}
export class ConsoleLogger {
    debug = console.debug;
    trace = console.trace;
    info = console.info;
    warn = console.warn;
    error = console.error;
}
export class MemoryLogger {
    records = [];
    limit = 0;
    debug;
    trace;
    info;
    warn;
    error;
    constructor(limit = 0) {
        this.limit = limit;
        for (const type of LOG_TYPES) {
            this[type] = this.append.bind(this, type);
        }
    }
    append(type, message, ...args) {
        if (this.limit > 0 && this.records.length >= this.limit) {
            this.records.shift();
        }
        this.records.push([Date.now(), type, message, ...args]);
    }
    getRecords() {
        return this.records.map(([date, type, message, ...args]) => {
            if (message !== null && message !== undefined && message.constructor === String) {
                message = message.trim();
            }
            return [date, type, message, ...args];
        });
    }
    getReplacer(sanitize) {
        return (key, value) => {
            if (value === null || value === undefined) {
                return value;
            }
            if (value instanceof BaseConfidential) {
                value = sanitize ? value.censored() : value.uncensored;
            }
            for (const allowedType of ALLOWED_TYPES) {
                if (value.constructor === allowedType) {
                    return value;
                }
            }
            if (value instanceof Error) {
                return value.toString();
            }
            if (value instanceof ArrayBuffer) {
                return `[ArrayBuffer: length=${value.byteLength}]`;
            }
            if (value instanceof Uint8Array) {
                return `[Uint8Array: length=${value.byteLength}, offset=${value.byteOffset}]`;
            }
            if (value instanceof Blob) {
                return `[Blob: length=${value.size}, type=${value.type}]`;
            }
            if (value.constructor === Object) {
                return value;
            }
            return `[${value.constructor.name}]`;
        };
    }
}
